// src/layouts/HeaderUnifiedLayout.jsx
import { Outlet, useLocation, ScrollRestoration } from "react-router-dom";
import HeaderUnified from "../Components/Header/HeaderUnified.jsx";
import LocationModal from "../Components/Location/LocationModal.jsx";
import InstallPWAButton from "../Components/InstallPWAButton.jsx";
import ReplaceCartConfirm from "../Components/Cart/ReplaceCartConfirm.jsx";
import QuickAddOptions from "../Components/Cart/QuickAddOptions.jsx";
import { BusinessesProvider } from "../context/BusinessesContext.jsx";
import { useUserLocation } from "../context/LocationContext";
import { useState } from "react";

export default function HeaderUnifiedLayout() {
  const [searchComponent, setSearchComponent] = useState(null);
  const { isLocationModalOpen, openLocationModal, closeLocationModal } = useUserLocation();
  const location = useLocation();
  const hideHeaderOnRoutes = ["/home", "/grocery", "/cart", "/checkout", "/delivery-tracking", "/new-address", "/new-user-info", "/favorites", "/profile", "/budget-meals"];

  const shouldHideHeader = hideHeaderOnRoutes.includes(location.pathname)
    || location.pathname.startsWith('/business/');

  return (
    <BusinessesProvider>
      <div className="min-h-screen text-black">
        {!shouldHideHeader && (
          <HeaderUnified
            searchComponent={searchComponent}
            onOpenLocationModal={openLocationModal}
          />
        )}
        <main>
          <Outlet context={{ setSearchComponent }} />
        </main>

        <LocationModal
          isOpen={isLocationModalOpen}
          onClose={closeLocationModal}
        />

        <InstallPWAButton />
        {/* Modal global: aparece cuando se intenta agregar producto de otro
            negocio mientras el carrito tiene items de uno distinto. */}
        <ReplaceCartConfirm />
        {/* Hoja de extras del "+" de las tarjetas, para productos con extras. */}
        <QuickAddOptions />
        <ScrollRestoration getKey={(location) => location.pathname} />
      </div>
    </BusinessesProvider>
  );
}
